import { RouteConfig } from "vue-router";

export const REmployerAccount: RouteConfig = {
  path: "my-account",
  name: "MyAccount",
  component: () =>
    import(
      /* webpackChunkName: "employer-my-account" */
      "./VEmployerAccount.vue"
    ),
  meta: {
    title: "My account",
  },
};
